import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from "react-helmet-async";

/** Placeholder blog posts – replace with real data later. */
const BLOG_POSTS = [
  { id: 1, slug: 'introducing-whitstable-house-proactive-rehab-centre', title: 'Introducing Rodwell House Proactive Rehab Centre', caption: 'Our CQC-registered rehabilitation service offers structured, intensive recovery programmes with specialist equipment and 24-hour nurse-led care – for early discharge, post-operative recovery and more.', image: '/Smart Balance 405 H.jpg' },
  { id: 2, slug: 'funding-care-home-fees-whitstable', title: 'Funding Care Home Fees in Whitstable', caption: 'Worried about how to pay for care? This guide breaks down the funding options available in Whitstable - from local authority support to self-funding and NHS contributions - so you can plan with confidence.', image: '/Screenshot 2026-02-25 at 10.09.36.png' },
  { id: 3, slug: 'guide-choosing-care-home-whitstable', title: 'A Guide to Choosing a Care Home in Whitstable', caption: 'Choosing a care home is a big decision. From visiting multiple homes and checking CQC ratings to understanding funding and specialist support, this essential checklist will help you make a confident, informed choice.', image: '/Screenshot 2026-02-25 at 09.47.36.png' },
  { id: 4, slug: 'understanding-different-stages-dementia', title: 'Understanding the Different Stages of Dementia', caption: 'Dementia affects everyone differently. We explain the typical stages, how symptoms may change over time, and what families can expect as care needs evolve.', image: '/Screenshot 2026-02-25 at 09.51.29.png' },
  { id: 5, slug: 'is-it-time-for-care-home', title: 'Is it time for a care home?', caption: 'Recognising when extra support is needed isn\'t always easy. This article explores the signs that it might be time to consider care – and how to approach the conversation with sensitivity.', image: '/Screenshot 2026-02-25 at 09.50.55.png' },
  { id: 6, slug: 'what-is-person-centred-care', title: 'What is person-centred care?', caption: 'Person-centred care puts the individual at the heart of every decision. Discover what this approach really means in practice and why it makes such a difference to quality of life.', image: '/Screenshot 2026-02-25 at 09.50.24.png' },
  { id: 7, slug: 'how-palliative-care-funded-uk', title: 'How is Palliative Care Funded in the UK?', caption: 'Palliative care funding can feel complex. We outline what\'s covered by the NHS, when financial assessments apply, and where families can turn for guidance and support.', image: '/Screenshot 2026-02-25 at 09.56.05.png' },
  { id: 8, slug: 'what-to-pack-moving-care-home-checklist', title: 'What to Pack When Moving into a Care Home: A Checklist', caption: 'Preparing for moving day? Our practical checklist covers everyday essentials, personal comforts, and important paperwork to help make the transition as smooth as possible.', image: '/Screenshot 2026-02-25 at 10.14.08.png' },
  { id: 9, slug: 'guide-moving-hospital-care-home', title: 'A Guide to Moving from Hospital into a Care Home', caption: 'Leaving hospital and arranging ongoing care can feel overwhelming. This guide explains the discharge process, assessments, funding considerations, and how to ensure continuity of care.', image: '/Screenshot 2026-02-25 at 09.40.06.png' },
];

function HelpAndAdvice() {
  return (
    <>
    <Helmet>
        <title> Help and Advice for Care Home Residents and Families </title>
        <meta
          name="description"
          content="A collection of helpful articles and guides for care home residents and families, covering a range of topics from moving into a care home to understanding different stages of dementia."
        />
        <link rel="canonical" href="https://www.whitstable.house/help-and-advice"/>
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section help-and-advice-page">
          <div className="help-and-advice-container">
            <h1>Help and Advice</h1>

            <div className="help-and-advice-blog-grid">
              {BLOG_POSTS.map((post) => (
                <Link
                  key={post.id}
                  to={`/help-and-advice/post/${post.slug}`}
                  className="help-and-advice-blog-card"
                >
                  <div className="help-and-advice-blog-card__image" aria-hidden="true">
                    {post.image ? (
                      <img src={post.image} alt="" />
                    ) : null}
                  </div>
                  <div className="help-and-advice-blog-card__body">
                    <h2 className="help-and-advice-blog-card__title">{post.title}</h2>
                    {post.caption ? (
                      <p className="help-and-advice-blog-card__caption">{post.caption}</p>
                    ) : (
                      <p className="help-and-advice-blog-card__caption help-and-advice-blog-card__caption--placeholder">
                        Caption to be added
                      </p>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <section className="footer__enquiry">
          <div className="footer__enquiry-container">
            <Link to="/contact-us" className="footer__enquiry-link">
              Enquire about Graham Care <span className="footer__arrow">▶</span>
            </Link>
          </div>
        </section>
        <div className="footer__container">
          <section className="contact-section">
            <div className="contact-section__content">
              <p>Graham Care Ltd, KT15 1HH</p>
              <p>Copyright © Graham Care Ltd</p>
            </div>
          </section>
        </div>
      </footer>
    </div>
    </>
  );
}

export default HelpAndAdvice;
